"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _numberFormatter = require("../../../helpers/numberFormatter");
require("./PaddedDecimal.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var PaddedDecimal = function PaddedDecimal(props) {
  var suffix = props.bemMod && props.bemMod.length ? '--' + props.bemMod : '';
  var parsed = (0, _numberFormatter.getParsedDecimal)(props.value, props.decimals);
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "ap-padded-decimal".concat(suffix)
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "ap-padded-decimal__units".concat(suffix)
  }, parsed.units), parsed.decimals && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "ap-padded-decimal__decimal-separator".concat(suffix)
  }, parsed.decimalSeparator), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ap-padded-decimal__decimals".concat(suffix)
  }, parsed.decimals), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ap-padded-decimal__padding".concat(suffix)
  }, parsed.padding)));
};
PaddedDecimal.propTypes = {
  value: _propTypes["default"].any,
  decimals: _propTypes["default"].number,
  bemMod: _propTypes["default"].string
};
PaddedDecimal.defaultProps = {
  value: 0,
  decimals: 2,
  bemMod: null
};
var _default = exports["default"] = PaddedDecimal;